import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosRequest } from "../../shared/components/helpers/axiosHelper";
import {
  calculateTotals,
  formatAmount,
} from "../../DonationSubscription/components/helpers/cartHelper";

const initialState = {
  party_id: "",
  donation_package_id: "",
  start_date: "",
  grand_total: "",
  type: "one-time",
  interval: 1,
  interval_unit: "month",
  donation_subscription_number: "",
  expires_after: "",
  created_by: 1,
  donation_subscription_items: {
    donation_package_id: "",
    donation_package_code: "",
    price: null,
    quantity: 1,
    tax_code: "GST_NONE",
    is_tax_included: 0,
    tax_total: 0,
    total: null,
    tax: 0,
    tax_amount: 0,
  },
  tax_total: 0,
  cgst_total: 0,
  sgst_total: 0,
  party: {
    name: "",
    mobile: "",
    party_address: [],
  },
};

export const fetchSubscriptionNumber = createAsyncThunk(
  "createSubscription/fetchSubscriptionNumber",
  async ({ token, tenantId }) => {
    const response = await axiosRequest({
      method: "GET",
      url: "donations/next-subscription-number",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "X-Tenant": tenantId,
      },
    });
    return response.data;
  }
);

const createDonationSubscriptionSlice = createSlice({
  name: "createSubscription",
  initialState,
  reducers: {
    updateTotals(state, action) {
      const items = action.payload;
      state.donation_subscription_items = items;
      const totals = calculateTotals(items);

      state.total_quantity = totals.total_quantity;
      state.subtotal = totals.subtotal.toFixed(2);
      state.taxable_value = totals.taxable_value.toFixed(2);
      state.tax_total = totals.tax_total.toFixed(2);
      state.cgst_total = totals.cgst_total.toFixed(2);
      state.sgst_total = totals.sgst_total.toFixed(2);
      state.grand_total = formatAmount(totals.grand_total);
    },
    AddNewSubscription(state, action) {
      state.subscription = action.payload;
      state.data = true;
    },
    changeDonationPackageId(state, action) {
      state.donation_package_id = action.payload;
    },
    changeSubscriptionNumber(state, action) {
      state.donation_subscription_number = action.payload;
    },
    changeStartDate(state, action) {
      state.start_date = action.payload;
    },
    changeExpiresAfter(state, action) {
      state.expires_after = action.payload;
    },
    changePaidAmount(state, action) {
      state.paid_amount = action.payload;
    },
    changePartyId(state, action) {
      state.party_id = action.payload;
    },
    changeGrandTotal(state, action) {
      state.grand_total = action.payload;
    },
    changeInterval(state, action) {
      state.interval = action.payload;
    },
    changeIntervalUnit(state, action) {
      state.interval_unit = action.payload;
    },
    changeType(state, action) {
      state.type = action.payload;
    },
    changeTaxTotal(state, action) {
      state.tax_total = action.payload;
    },
    changeCgstTotal(state, action) {
      state.cgst_total = action.payload;
    },
    changeSgstTotal(state, action) {
      state.sgst_total = action.payload;
    },
    changePlaceOfSupply(state, action) {
      state.place_of_supply = action.payload;
    },
    changeCreatedBy(state, action) {
      state.created_by = action.payload;
    },
    changePartyName(state, action) {
      state.party.name = action.payload;
    },
    changePartyMobile(state, action) {
      state.party.mobile = action.payload;
    },
    changePartyAddress(state, action) {
      state.party.party_address = action.payload;
    },
    changeDonationItemPrice(state, action) {
      state.donation_subscription_items.price = action.payload;
    },
    changeDonationItemQuantity(state, action) {
      state.donation_subscription_items.quantity = action.payload;
    },
    changeDonationItemTaxCode(state, action) {
      state.donation_subscription_items.tax_code = action.payload;
    },
    changeDonationItemIsTaxIncluded(state, action) {
      state.donation_subscription_items.is_tax_included = action.payload;
    },
    changeDonationItemTaxTotal(state, action) {
      state.donation_subscription_items.tax_total = action.payload;
    },
    changeDonationItemTotal(state, action) {
      state.donation_subscription_items.total = action.payload;
    },
    changeDonationItemTax(state, action) {
      state.donation_subscription_items.tax = action.payload;
    },
    changeDonationItemTaxAmount(state, action) {
      state.donation_subscription_items.tax_amount = action.payload;
    },
    resetSubscription: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(fetchSubscriptionNumber.fulfilled, (state, action) => {
        state.donation_subscription_number = action.payload;
      })
      .addCase(fetchSubscriptionNumber.rejected, (state) => {
        state.error = "Error while getting subscription number. Please try again later.";
      });
  },
});

export default createDonationSubscriptionSlice.reducer;

export const {
  AddNewSubscription,
  resetSubscription,
  updateTotals,
  changeDonationPackageId,
  changeSubscriptionNumber,
  changeStartDate,
  changeExpiresAfter,
  changePaidAmount,
  changePartyId,
  changeGrandTotal,
  changeInterval,
  changeIntervalUnit,
  changeType,
  changeTaxTotal,
  changeCessTotal,
  changeCgstTotal,
  changeSgstTotal,
  changeProduct,
  changePlaceOfSupply,
  changeCreatedBy,
  changeParty,
  changePartyName,
  changePartyMobile,
  changePartyAddress,
  changeDonationSubscriptionItems,
  changeDonationItemPrice,
  changeDonationItemQuantity,
  changeDonationItemTaxCode,
  changeDonationItemIsTaxIncluded,
  changeDonationItemTaxTotal,
  changeDonationItemTotal,
  changeDonationItemTax,
  changeDonationItemTaxAmount,
} = createDonationSubscriptionSlice.actions;